import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { ERROR_CODES } from '../../../../../services/exports/Constants';
import useOutOfStockErrorHandler from './useOutOfStockErrorHandler';
import useItemsUnavailableErrorHandler from './useItemsUnavailableErrorHandler';

const useOrderErrorHandler = () => {
  const outOfStockErrorHandler = useOutOfStockErrorHandler();
  const itemsUnavailableErrorHandler = useItemsUnavailableErrorHandler();

  const handler = (response: RenderableErrorResponse<any>) => {
    if (response.response.data.error_code === ERROR_CODES.ITEMS_OUT_OF_STOCK) {
      return outOfStockErrorHandler(response);
    }

    if (response.response.data.error_code === ERROR_CODES.ITEMS_MENU_TIME_UNAVAILABLE) {
      return itemsUnavailableErrorHandler(response);
    }
  };

  return handler;
};

export default useOrderErrorHandler;
